export default function capitaliseFirstLetter(string) {
  return string && string[0]?.toUpperCase() + string.slice(1);
}
